import React, { useState, useEffect } from "react";
import MaterialTable from "@material-table/core";
import * as APIModels from "../../../models";
import { TylerAdminService } from "../../../services/ClientService";
import { Attorney } from "../../../models/swagger/generated-submission-service";
import AttorneyUpdateModal from "./modals/AttorneyUpdateModal";
import {
    ErrorModal,
    ErrorModalProps,
} from "../../../components/shared/modals/ErrorModal";
import { Globals } from "../../../helpers/globals";

export default function TylerAttorney() {
    const [data, setData] = useState([] as Attorney[]);
    const [updating, setUpdating] = useState({} as Attorney);
    const [modal, setModal] = useState(false);
    const [updateMessageError, setUpdateMessageError] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const portal = Globals.portalValue;

    const errorModalProps: ErrorModalProps = {
        errorMessage: "",
        onClose: () => {
            setError("");
            setModal(false);
        },
    };

    useEffect(() => {
        if (error !== "") {
            errorModalProps.errorMessage = error;
            setModal(true);
        } else {
            setModal(false);
            errorModalProps.errorMessage = "";
        }
    }, [error]);

    useEffect(() => {
        TylerAdminService.getAttorneys().then((res) => {
            if (res.successful && res) {
                if (!res.data || res.data!.length === 0) {
                    setData([
                        {
                            barNumber: "00000",
                            firstName: "No",
                            lastName: "Attorneys",
                            emailAddress: "contact@tylertech.xyz",
                        },
                    ] as Attorney[]);
                    setError("No attorneys found!");
                } else {
                    console.log([...res.data!]);
                    setData((_prev) => {
                        return [...res.data!] as Attorney[];
                    });
                    setSuccess("Loaded attorneys successfully!");
                }
            }
        });
    }, []);

    const attorneyModal = () => {
        setModal(true);
    };

    const updateAttorney = async (attorney: Attorney) => {
        const response = await TylerAdminService.updateAttorney({
            body: attorney,
        });
        if (response.successful) {
            setData((prev) => {
                const index = prev.findIndex(
                    (a) => a.barNumber === attorney.barNumber
                );
                prev[index] = attorney;
                return [...prev];
            });
            setModal(false);
            setUpdating({} as Attorney);
            setSuccess("Attorney updated successfully!");
        } else {
            console.log(response.errorMessage);
            setUpdateMessageError(response.errorMessage!);
        }
    };

    const deleteAttorney = async (attorney: Attorney) => {
        try {
            const response = await TylerAdminService.deleteAttorney({
                id: attorney.id ?? APIModels.EmptyGuid,
            });
            if (response.successful) {
                setData((prev) => {
                    return prev.filter(
                        (att) => att.barNumber !== attorney.barNumber
                    );
                });
            } else {
                console.log(response.errorMessage);
                setError(response.errorMessage!);
            }
        } catch (e) {
            // setError(e.message);
        }
    };

    return (
        <div className="row my-3">
            <AttorneyUpdateModal
                updating={updating}
                addAttorneyModal={false}
                close={() => {
                    setModal(false);
                    setUpdating({} as Attorney);
                }}
                updateAttorney={updateAttorney}
                message={updateMessageError}
            />
            {error && <ErrorModal {...errorModalProps} />}
            <div className="col-12">
                <div style={{ maxWidth: "100%" }}>
                    <MaterialTable
                        columns={[
                            { title: "Bar Number", field: "barNumber" },
                            { title: "First Name", field: "firstName" },
                            { title: "Last Name", field: "lastName" },
                        ]}
                        data={data}
                        title="Attorneys"
                        options={{
                            actionsColumnIndex: -1,
                            pageSizeOptions: [5, 10, 20, 50, 75, 100],
                        }}
                        editable={{
                            onRowAdd: (newData) => {
                                return new Promise((resolve, _reject) => {
                                    newData.state = portal;
                                    TylerAdminService.addAttorney({
                                        body: newData,
                                    }).then((res) => {
                                        if (res.successful && res.data) {
                                            setData((prev) => {
                                                return [...prev, newData];
                                            });
                                            resolve(null);
                                        } else {
                                            setError(res.errorMessage!);
                                        }
                                    });
                                });
                            },
                            onRowUpdate: (newData, oldData) => {
                                newData.state = portal;
                                console.log(newData);
                                return new Promise((resolve, reject) => {
                                    TylerAdminService.updateAttorney({
                                        body: newData,
                                    }).then((res) => {
                                        if (res.successful) {
                                            setData((prev) => {
                                                const index = prev.findIndex(
                                                    (a) =>
                                                        a.barNumber ===
                                                        newData.barNumber
                                                );
                                                prev[index] = newData;
                                                return [...prev];
                                            });
                                            resolve(null);
                                        } else {
                                            setError(res.errorMessage!);
                                            reject(oldData);
                                        }
                                    });
                                });
                            },
                            onRowDelete: (oldData) => {
                                return new Promise((resolve, _reject) => {
                                    TylerAdminService.deleteAttorney({
                                        id: oldData.id ?? APIModels.EmptyGuid,
                                    }).then((res) => {
                                        if (res.successful) {
                                            setData((prev) => {
                                                return prev.filter(
                                                    (att) =>
                                                        att.id !== oldData.id
                                                );
                                            });
                                            resolve(null);
                                        } else {
                                            setError(res.errorMessage!);
                                        }
                                    });
                                });
                            },
                        }}
                    />
                </div>
            </div>
            {error !== "" && (
                <div className="col-12 p-2">
                    <div className="alert alert-danger">{error}</div>
                </div>
            )}
            {success !== "" && (
                <div className="col-12 p-2">
                    <div className="alert alert-success">{success}</div>
                </div>
            )}
        </div>
    );
}
